"use client";

import { c as _c } from "react/compiler-runtime";
import { locale } from "@locale";
import classNames from "classnames";
import { useState } from "react";
import Button from "src/components/button/Button";
import InlineCinemaFilter from "src/components/filterselector/InlineCinemaFilter";
import { GENRE_FAMILIEFILM } from "src/components/filterselector/validFilterValues";
import DeletableLabelledCheck from "src/components/labelledcheck/DeletableLabelledCheck";
import CloseSvg from "src/components/svg/CloseSvg";
import { useLocationContext, useProgramDatesContext, useProgramFilterContext, useSelectedCinemaContext } from "src/lib/contexts/ContextTypes";
import getThemeStyles from "src/lib/styling/getThemeStyles";
import styles from "./CurrentFilter.module.css";

//#region [Props]
type CurrentFilterProps = {
  /** e.g. on a film page, where there is no ProgramFilterWrapper and filtering on genre makes no sense */
  hideFamilyFilter?: boolean;
};
//#endregion

//#region [Component]
export default function CurrentFilter(t0) {
  const $ = _c(20);
  const {
    hideFamilyFilter: t1
  } = t0;
  const hideFamilyFilter = t1 === undefined ? false : t1;
  const cinemaContext = useSelectedCinemaContext();
  const filterContext = useProgramFilterContext();
  const locationContext = useLocationContext();
  const themeStyles = getThemeStyles(styles);
  const selectedCinemas = (cinemaContext.selectedCinemas?.length ?? 0) > 0 ? cinemaContext.availableCinemas.filter(acin => cinemaContext.selectedCinemas.includes(acin.name)) : null;
  let t2;
  if ($[0] !== filterContext?.genres) {
    t2 = filterContext?.genres?.includes(GENRE_FAMILIEFILM);
    $[0] = filterContext?.genres;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const isFamilySelected = t2;
  const [isShowingFilter, setIsShowingFilter] = useState(false);
  const {
    selectedDate
  } = useProgramDatesContext();
  let t3;
  if ($[2] !== selectedDate) {
    t3 = selectedDate?.getTime();
    $[2] = selectedDate;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [prevDateTime, setPrevDateTime] = useState(t3);
  if (selectedDate?.getTime() !== prevDateTime) {
    setPrevDateTime(selectedDate?.getTime());
    setIsShowingFilter(false);
  }
  const hasLocation = (locationContext.location?.length ?? 0) > 0;
  const canChooseCinemas = cinemaContext.availableCinemas.length > 1;
  if (!hasLocation || !canChooseCinemas && hideFamilyFilter) {
    return null;
  }
  const t4 = classNames(themeStyles, styles.CurrentFilterContainer);
  let t5;
  if ($[4] !== canChooseCinemas || $[5] !== isShowingFilter) {
    t5 = canChooseCinemas && <Button text={isShowingFilter ? locale.actions.close : locale.program.moreCinemas} borderStyle="roundedSquare" isOutline={true} fwVariant="outlineGradient1" dkVariant="darkOutline" className={classNames(styles.OutlineButton, styles.PreBreakButton)} onClick={() => setIsShowingFilter(!isShowingFilter)} />;
    $[4] = canChooseCinemas;
    $[5] = isShowingFilter;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== filterContext || $[8] !== hideFamilyFilter || $[9] !== isFamilySelected) {
    t6 = !hideFamilyFilter && <DeletableLabelledCheck value={GENRE_FAMILIEFILM} className={classNames(styles.FamilyCheck, styles.PreBreakButton)} label={locale.program.familyMovies} selected={isFamilySelected} fwVariant="outlineGradient1" dkVariant="darkOutline" borderStyle="roundedSquare" selectionCallback={isSelected => filterContext.applyFilter({
      genres: !isSelected ? [] : [GENRE_FAMILIEFILM]
    })} />;
    $[7] = filterContext;
    $[8] = hideFamilyFilter;
    $[9] = isFamilySelected;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = canChooseCinemas && !isShowingFilter && selectedCinemas?.map(cinema => <Button key={cinema.name} text={cinema.name} borderStyle="roundedSquare" dkVariant="darkOutline" icon={<CloseSvg className={styles.CloseIcon} />} onClick={() => cinemaContext.removeSelectedCinema(cinema.name)} className={classNames(styles.FilterButton, styles.PostBreakButton)} />);
  let t8;
  if ($[11] !== canChooseCinemas || $[12] !== isShowingFilter) {
    t8 = canChooseCinemas && <InlineCinemaFilter className={styles.InlineFilterSelector} showFilter={isShowingFilter} />;
    $[11] = canChooseCinemas;
    $[12] = isShowingFilter;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t4 || $[15] !== t5 || $[16] !== t6 || $[17] !== t7 || $[18] !== t8) {
    t9 = <div className={t4}>{t5}{t6}{t7}{t8}</div>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}
//#endregion